/*
 * Countdown timer
 * Uses mtc_the_final_countdown.js & mtc_moments.js
 */

window.lazyLoadCountdownLibs = function lazyLoadCountdownLibs() {
    if ($('.js_countdownBannerWrap').length) {
        setTimeout(function () {
            $.getScript('/core/js/plugins/mtc_the_final_countdown_and_moments.js', function () {
                countdownTimer();
            });
        }, 1500);
    }
}

window.countdownTimer = function countdownTimer() {

    if ($('.js_countdownBannerWrap').length) {
        // https://github.com/moment/moment-timezone/blob/develop/data/packed/latest.json
        moment.tz.add('Europe/London|GMT BST BDST|0 -10 -20|0101010101010101010101010101010101010101010101010121212121210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|10e6');

        var countdown_timer = $('.js_countdownTimerWrap'),
            $this = countdown_timer,
            final_date = $this.data('closing-date'),
            locale_fix = moment(final_date, "YYYY/MM/DD HH:mm:ss").tz('Europe/London').format('YYYY/MM/DD HH:mm:ss');

        $this.countdown(locale_fix, function (e) {
            $this.find('.js_countdownTimer').html(e.strftime(''
                + '<li><span class="digits">%D</span></li>'
                + '<li>:</li>'
                + '<li><span class="digits">%H</span></li>'
                + '<li>:</li>'
                + '<li><span class="digits">%M</span></li>'
                + '<li>:</li>'
                + '<li><span class="digits">%S</span></li>'
            ));
        });
    }
}

$(document).ready(function () {

    /*
     * force strict mode
     */

    'use strict';

    lazyLoadCountdownLibs();

}); // document ready